export default __webpack_public_path__ + "static/media/zapier.5775d718.svg";